import * as marked from 'marked';

import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrganizationConfig } from '../../../../../../../models/organization-config';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-preview-email-opt-in-modal',
  templateUrl: './preview-email-opt-in-modal.component.html',
  styleUrls: ['./preview-email-opt-in-modal.component.css']
})
export class PreviewEmailOptInModalComponent {
  @Input() orgConfig: OrganizationConfig;

  constructor(
    public activeModal: NgbActiveModal,
    private domSanitizer: DomSanitizer
  ) {}

  public getRenderedCheckboxText() {
    return this.domSanitizer.bypassSecurityTrustHtml(
      marked.parseInline(
        this.orgConfig.email_opt_in_checkbox_text,
        {
          breaks: true
        }
      )
    );
  }

  public getRenderedHelpText() {
    return this.domSanitizer.bypassSecurityTrustHtml(
      marked(
        this.orgConfig.email_opt_in_help_text,
        {
          breaks: true
        }
      )
    );
  }

}
